import { Modal } from '@lorndev/modal'

(() => {
    console.log('run');
    document.querySelectorAll('.popup-content').forEach(element => {

        const modal = new Modal({ closeButton: true, closeOverlay: true, transition: '200ms' });
        const modalContent = element;

        modal.addModalClass('homepage-popup');
        modal.addChild(modalContent);
        modal.insert();
        modal.open();
    });
})();
